import { render } from "./Addons.vue?vue&type=template&id=2202c7de&scoped=true"
import script from "./Addons.vue?vue&type=script&lang=js"
export * from "./Addons.vue?vue&type=script&lang=js"

import "./Addons.vue?vue&type=style&index=0&id=2202c7de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2202c7de"]])

export default __exports__